import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/RejectConnectExternalServiceToAccount.graphql';
import { Mutation, MutationrejectConnectExternalServiceToAccountArgs } from '../../__generated__/globalTypes';

export const useRejectConnectExternalServiceToAccountMutation = (
  options?: MutationHookOptions<Mutation, MutationrejectConnectExternalServiceToAccountArgs>
) => {
  const [callRejectConnectExternalServiceToAccount, result] = useMutation<
    Mutation,
    MutationrejectConnectExternalServiceToAccountArgs
  >(MUTATION, options);

  return { callRejectConnectExternalServiceToAccount, ...result };
};

export type RejectConnectExternalServiceToAccountMutationFunction = Mutation['rejectConnectExternalServiceToAccount'];
